/**
 * Edge Home Finance — brand constants + legal disclosure copy.
 * Pierre Joseph is a Realtor at Gens Realty AND a Loan Officer at Edge Home Finance.
 */

// v-query forces browser cache refresh when logo asset changes
export const EDGE_LOGO = "/edge-home-finance-logo.png?v=20260208";

export const EDGE = {
  name: "Edge Home Finance",
  legal: "Edge Home Finance Corporation",
  nmls: "891464",
  email: "info@edgehomefinance.com",
  phone: "(763) 219-8484",
  tollFree: "1-800-595-8560",
  address: {
    street: "5860 Baker Road",
    city: "Minnetonka, MN 55345",
  },
  officer: {
    name: "Pierre Joseph",
    nmls: "1978260",
    phone: "832-741-4662",
    email: "pierre.joseph@edgehomefinance.com",
    bioLink: "https://edgehomefinance.com/team-member/pierre-joseph/",
    title: "Loan Officer · NMLS #1978260",
    realtorNumber: "0537207",
  },
};

export const EDGE_NAVY = "#1E3A6D"; // deep navy from logo
export const EDGE_NAVY_DARK = "#172A4F";

// Edge Home Finance's official 1003 online application system,
// personalized for Pierre Joseph (NMLS #1978260).
export const EDGE_APP_URL = "https://edge.my1003app.com/1978260/register?lang=en";
